<template>
	<span v-text="prettyFormat" />
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default {
	name: 'PrettyPhone',
	// user will be preferred but will fallback to phone
	props: { user: Object, phone: String },
	computed: {
		phoneNumber() {
			return this.user?.phones?.[0]?.phone ?? this.user?.phone ?? this.phone
		},
		parsed() {
			if (!this.phoneNumber) return ''
			return parsePhoneNumberFromString(this.phoneNumber)
		},
		prettyFormat() {
			if (!this.parsed) return ''
			return this.parsed.formatInternational()
		},
	},
}
</script>
